import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMutation } from '@apollo/client/react';
import { Box } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { useError } from 'contexts/error';
import { useInfo } from 'contexts/info';
import Container from 'components/layout/container';
import { WhiteCard } from 'components/styles_components/card';
import ConnectGoogleDriveMutation from 'mutations/user/connect_google_drive';
import { GOOGLE_REDIRECT_URI } from 'utils/google_oauth';
import { ChapterTypography } from 'components/styles_components/typography';
import { ProfileLink } from 'utils/link';
import Loader from 'components/loader';


const GoogleCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const setError = useError();
  const setInfo = useInfo();

  const [connectGoogleDrive] = useMutation(ConnectGoogleDriveMutation, {
    onCompleted: ({ connectGoogleDrive: result }) => {
      if (result?.storageProvider) {
        setInfo('info.storage.connected');
        navigate(ProfileLink());
      } else {
        setError('error.storage.connect');
        navigate(ProfileLink());
      }
    },
    onError: () => {
      setError('error.storage.connect');
      navigate(ProfileLink());
    },
  });


  useEffect(() => {
    const code = searchParams.get('code');
    const error = searchParams.get('error');

    if (error || !code) {
      setError('error.storage.connect');
      navigate(ProfileLink());
    } else {
      connectGoogleDrive({
        variables: {
          code,
          redirectUri: GOOGLE_REDIRECT_URI,
        },
      });
    }
  }, [searchParams, connectGoogleDrive, navigate, setError]);

  return (
    <Container>
      <WhiteCard>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Loader />
          <ChapterTypography variant="h6">
            <FormattedMessage id="cloud_storage.connecting" />
          </ChapterTypography>
        </Box>
      </WhiteCard>
    </Container>
  );
};

export default GoogleCallback;
